import styled from 'styled-components'

export const TreatmentOptionsComponent = styled.div`
  margin-top: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin: 0 15px;
  }

  .accordion-option {
    margin-bottom: 15px;
  }

  // wrapper is required to decrease accordion content
  // to show drop shadow within the overflow:hidden accordion content container
  .wrapper {
    margin: 20px 1px 2px 0;
  }

  .content-header,
  .content-details {
    padding: 15px 20px 20px 30px;
    box-shadow: inset 6px 0 0 0 ${ (props) => props.theme.colors['aok-gruen'] };
  }

  .content-header {
    background-color: ${ (props) => props.theme.colors.weiss };

    .headline-alternative {
      margin-bottom: 15px;
    }
  }

  .content-details {
    background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
  }

  .content-container {
    box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  }

  .text-table {
    display: flex;
    flex-wrap: wrap;

    &-title {
      margin-bottom: 15px;
    }

    &-title,
    &-copy {
      flex-basis: 100%;
      overflow-wrap: anywhere;
      hyphens: auto;
    }

    &-tooltip {
      margin-left: 10px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      flex-wrap: nowrap;

      &-title {
        flex-basis: 30%;
      }

      &-copy {
        flex-basis: 70%;
      }
    }
  }

  .contact-icon {
    color: ${ (props) => props.theme.colors['icon-grau1'] };
    margin-right: 15px;
  }

  .location-icon {
    color: ${ (props) => props.theme.colors['icon-grau2'] };
    margin: 0 10px 0 0;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin: 0 10px 0 30px;
    }
  }

  .distance {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
  }

  .address-container {
    > * {
      display: block;
      margin-bottom: 10px;

      @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
        display: inline-block;
      }
    }
  }

  .phone-route-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > *:not(:last-child) {
      display: inline-block;
      margin-bottom: 10px;

      @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
        margin-bottom: 0px;
      }
    }
  }

  .route-button {
    padding: 0;
  }

  .accordion-content-container {
    margin: 20px 0 0;
  }

  .spacing-bottom {
    margin-bottom: 20px;
  }
`
